import { render, staticRenderFns } from "./AdminUserAddressesElement.vue?vue&type=template&id=627b848c&scoped=true"
import script from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUserAddressesElement.vue?vue&type=style&index=0&id=627b848c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b848c",
  null
  
)

export default component.exports